define('app/sdc/crud/controls/sdc-crud-controls',["$timeout"], function ($timeout) {
	return {
		restrict: "E",
		require: {
			"crud": "^sdcCrud"
		},
		controller: {
			//properties: {
			//	controlCount: function () { return (!!this.editable.canCreate + !!this.editable.canUpdate + !!this.editable.canDelete); }
			//}
		}
	};
});
